import { AnalyticsEvent, pushAnalyticsEvent } from 'utils/analytics';

export const pushSubmissionSuccess = (formId: string) =>
    pushAnalyticsEvent(AnalyticsEvent.FORM_SUBMISSION_SUCCESS, {
        formId,
    });

export const pushFormFieldError = ({
    formId,
    fieldId,
    errorMessage,
}: {
    formId: string;
    fieldId: string;
    errorMessage: string;
}) => {
    pushAnalyticsEvent(AnalyticsEvent.FORM_FIELD_ERROR, {
        formId,
        fieldId,
        errorMessage,
    });
};

export const pushSubmissionError = ({
    formId,
    fields,
}: {
    formId: string;
    fields: {
        fieldId: string;
        errorMessage: string;
    }[];
}) => {
    pushAnalyticsEvent(AnalyticsEvent.FORM_SUBMISSION_ERROR, {
        formId,
        fields,
    });
};

export const pushApiError = ({ formId, error }: { formId: string; error: string }) => {
    pushAnalyticsEvent(AnalyticsEvent.FORM_SUBMISSION_FAIL, {
        formId,
        error,
    });
};
